<template>
  <div class="orbit  chinese_container">
    <myHeader />
    <div class="bg">
      <div class="contain">
        <h1 class="wow fadeInUp ProductTitle">hecoos Mirror投影轨道镜</h1>
        <p class="wow fadeInUp TwoProductTitle">
          hecoos Mirror轨道镜拥有的投影画面控制能力灵活多变，<br />
          突破固定投影机在画面投射方向上单一固定的局限。
        </p>

        <div class="contain_button">

          <router-link :to="{
            name: 'chCaseDemonstration',
            hash: '#specific-position',
          }" class="setting_a2">
            <button class="contact-button wow fadeInUp">联系我们</button>
          </router-link>
        </div>
      </div>
    </div>

    <!-- <div class="swiper-slide">
      <div class="carousel-content">
        <video class="video_young" autoplay loop muted
          src="https://download.hecoos.com/enlightv/2025-11/639b0bf986e055fad0427e2ebd9c95ef.mp4"></video>
        <div class="carousel-overlay">
          <p class="carousel-title wow fadeInUp">点亮新视野</p>
          <button class="watch-movie-button wow fadeInUp" @click="showVideo(0)">
            <img src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png" alt="" />
          </button>
        </div>
      </div>
    </div> -->

    <div class="section_foundation">
      <div class="section_content">
        <p class="carousel-title wow fadeInUp">点亮新视野</p>
        <button class="watch-movie-button wow fadeInUp" @click="showVideo">
          <img src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png" alt="" />
        </button>
      </div>
      <div class="scroll_container">
        <div class="foundation_video">
          <video autoplay loop muted
            src="https://download.hecoos.com/enlightv/2025-11/639b0bf986e055fad0427e2ebd9c95ef.mp4"></video>
        </div>
      </div>
    </div>

    <div class="bg2">
      <div class="bg22">
        <p class="wow fadeInUp">硬件规格</p>
        <h1 class="wow fadeInUp ProductTitle">参数细细看</h1>
        <img src="https://download.hecoos.com/enlightv/2025-17/33df240596d55557bc9cbf984cfa9f0c.png"
          class="wow fadeInUp" />
      </div>
    </div>

    <div class="bg3">
      <div>
        <div class="content1 wow fadeInUp">
          <div class="con11">
            <h1>规则参数</h1>
          </div>
          <div class="con1">
            <p>设备尺寸(W/D/H):</p>
            <p>设备总重量:</p>
            <p>投影机重量:</p>
            <p>单镜子重量:</p>
            <p>桁架安装架MHZ-BT重量:</p>
            <p>壁挂式安装架MHZ-BW重量:</p>
            <p>扩展安装架MHZ-BE重量:</p>
            <p>落地架MHZ-BSH重量:</p>
          </div>
          <div class="con2">
            <p>{{ specParams.deviceSize }}</p>
            <p>{{ specParams.totalWeight }}</p>
            <p>{{ specParams.projectorWeight }}</p>
            <p>{{ specParams.mirrorWeight }}</p>
            <p>{{ specParams.btMountWeight }}</p>
            <p>{{ specParams.bwMountWeight }}</p>
            <p>{{ specParams.beMountWeight }}</p>
            <p>{{ specParams.bshMountWeight }}</p>
          </div>
        </div>
        <div class="content2 wow fadeInUp">
          <div class="con11">
            <h1>电器规格</h1>
          </div>
          <div class="con1">
            <p>输入功率:</p>
            <p>输出功率：</p>
          </div>
          <div class="con2">
            <p>{{ electricSpecs.inputPower }}</p>
            <p>{{ electricSpecs.outputPower }}</p>
          </div>
        </div>
        <div class="content3 wow fadeInUp">
          <div class="con11">
            <h1>操作规格</h1>
          </div>
          <div class="con1">
            <p>轨道镜倾斜模式：</p>
            <p>轨道镜平移模式:</p>
            <p>定位精准度误差：</p>
            <p>移动模式精度：</p>
          </div>
          <div class="con2">
            <p>{{ operationSpecs.tiltMode }}</p>
            <p>{{ operationSpecs.panMode }}</p>
            <p>{{ operationSpecs.positionError }}</p>
            <p>{{ operationSpecs.movementPrecision }}</p>
          </div>
        </div>
        <div class="content4 wow fadeInUp">
          <div class="con11">
            <h1>运行环境</h1>
          </div>
          <div class="con1">
            <p>工作环境温度范围:5°-35°C</p>
            <p>湿度:20%-80%(无冷凝)</p>
          </div>
          <div class="con2"></div>
        </div>
        <div class="content5 wow fadeInUp">
          <div class="con11">
            <h1>提供附件</h1>
          </div>
          <div class="con1">
            <p>RS232连接线</p>
            <p>交流回路电缆</p>
            <p>快速安装指南</p>
          </div>
          <div class="con2"></div>
        </div>
      </div>
    </div>

    <div class="titlebg4">
      <div>
        <div class="bg4text1">
          <h1 class="ProductTitle">作品呈现</h1>
        </div>
      </div>
    </div>

    <!-- <div class="swiper-slide">
      <div class="carousel-content">
        <video class="video_young" autoplay loop muted
          src="https://download.hecoos.com/enlightv/2025-11/4dbbdd6f1ceda8ebe264e9e876155cbd.mp4"></video>
        <div class="carousel-overlay">
          <button class="watch-movie-button wow fadeInUp" @click="showVideo(1)">
            <img src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png" alt="" />
          </button>
        </div>
      </div>
    </div> -->

    <div class="section_foundation">
      <div class="section_content">
        <!-- <p class="carousel-title wow fadeInUp">点亮新视野</p> -->
        <button class="watch-movie-button wow fadeInUp" @click="showVideo(1)">
          <img src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png" alt="" />
        </button>
      </div>
      <div class="scroll_container">
        <div class="foundation_video">
          <video autoplay loop muted ref="videoRef"
            src="https://download.hecoos.com/enlightv/2025-11/4dbbdd6f1ceda8ebe264e9e876155cbd.mp4"></video>
        </div>
      </div>
    </div>

    <div class="bg4">
      <div>
        <div class="bg4text">
          <div class="qq1">
            <h3 class="qq wow fadeInUp">{{ textaerass.titletext }}</h3>
            <p class="wow fadeInUp">{{ textaerass.pagetext }}</p>
          </div>
        </div>
      </div>
    </div>

    <my-inquire />
    <my-footer />
    <BackToTop></BackToTop>
    <videoPlayback v-if="showVideoPlayer" @close="handleCloseVideo" :videoUrl="videoUrl" />
  </div>
</template>

<script>
import myFooter from "@/components/pc/myFooter.vue";
import myHeader from "@/components/pc/myHeader.vue";
import myInquire from "@/components/pc/myInquire.vue";
import BackToTop from "@/components/pc/BackToTop";
import videoPlayback from "@/components/pc/videoPlayback.vue";
export default {
  components: {
    myHeader,
    myFooter,
    myInquire,
    BackToTop,
    videoPlayback,
  },
  mounted() {
    const video = this.$refs.videoRef;
    video.addEventListener('timeupdate', () => {
      const remainingTime = video.duration - video.currentTime;
      if (remainingTime <= 3) {
        video.pause();
      }
    });
  },
  data() {
    return {
      showVideoPlayer: false,
      videoUrl: "https://download.hecoos.com/enlightv/2025-11/639b0bf986e055fad0427e2ebd9c95ef.mp4",
      specParams: {
        deviceSize: "498mmx265mmx749mm",
        totalWeight: "25.8kg",
        projectorWeight: "16.3kg",
        mirrorWeight: "9.3kg",
        btMountWeight: "2.2kg",
        bwMountWeight: "2.8kg",
        beMountWeight: "3.3kg",
        bshMountWeight: "12.5Kg",
      },
      electricSpecs: {
        inputPower: "100-240V/2-1A/50-60Hz，最大10A(+C14插座)",
        outputPower: "投影机交流回路槽(3针C13母插口)",
      },
      operationSpecs: {
        tiltMode: "90度和162度",
        panMode: "180度",
        positionError: "<0.03°",
        movementPrecision: "同一方向平移或倾斜到设定好的位置，误差在0.01左右",
      },
      environmentSpecs: {
        temperatureRange: "5°-35°C",
        humidity: "20%-80%(无冷凝)",
      },
      textaerass: {
        titletext: "《致敬生命拯救者》光影行为艺术",
        pagetext:
          "2021新年伊始，在天津广播电视塔2021跨年灯光秀上，一场4分30秒的“光影行为艺术”《致敬生命拯救者》在天津广播电视塔上呈现了一个唯美又惊心动魄的故事。在呈现过程中，主创团队使用hecoos Mirror与Server-R媒体服务器配合保障作品的呈现。画面最高点在现场呈现时，主创团队使用轨道镜、高流明工程投影仪、hecoos全域媒体创作平台等前沿的硬软体媒介来保证实验过程与现场呈现的真实度。投影机配载自主编程的轨道镜系统进行建筑体投射，画面最高点达260米，也使得这件作品成为在投射范围、设备使用极简性上的一件代表性投影作品。",
      },
      formData: {
        name: "",
        phone: "",
        city: "",
        email: "",
        company: "",
        position: "",
        message: "",
      },
    };
  },
  methods: {
    //     handleSubmit(event) {
    //   event.preventDefault();
    //   // 在此处添加表单提交后的处理逻辑，例如发送数据到服务器
    //   console.log(this.formData);
    // }
    // 显示视频播放器
    showVideo(n) {
      if(n == 1){
        this.videoUrl = "https://download.hecoos.com/enlightv/2025-11/f441eac9aa01246106ff61af11ddefd5.mp4"
      }else{
        this.videoUrl = "https://download.hecoos.com/enlightv/2025-11/639b0bf986e055fad0427e2ebd9c95ef.mp4"
      }
      this.showVideoPlayer = true;
      document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = 'auto'; // 恢复页面滚动
    },
  },
};
</script>


<style scoped lang="scss">
@import "@/styles/wsc.scss";
@import "@/styles/optimize_adaptation.scss";
</style>
